import { render, staticRenderFns } from "./replacement-batch.vue?vue&type=template&id=705bbd1f&scoped=true"
import script from "./replacement-batch.vue?vue&type=script&lang=js"
export * from "./replacement-batch.vue?vue&type=script&lang=js"
import style0 from "./replacement-batch.vue?vue&type=style&index=0&id=705bbd1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705bbd1f",
  null
  
)

export default component.exports